import { Component, OnInit } from '@angular/core';

import { OwlOptions } from 'ngx-owl-carousel-o';

import { ActivatedRoute , Router } from '@angular/router';

import { Title, Meta } from '@angular/platform-browser'; 
import { ApiService } from '../api.service';
import {HELP_TITLE,HELP_KEYWORDS,HRLP_CONTENT,HELP_DESC,HELP_DESC_CONTENT} from  'src/app/seoconstants';  

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  title:string;
  keywords:string;
  keywordcontent:string;
  desc:string;
  desccontent:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private titleService: Title, private metaService: Meta) { }

  ngOnInit() {

    this.title = HELP_TITLE;
    this.keywords = HELP_KEYWORDS;
    this.keywordcontent = HRLP_CONTENT;
    this.desc = HELP_DESC;
    this.desccontent = HELP_DESC_CONTENT;


    this.titleService.setTitle(this.title);
  this.metaService.addTags([
    {name: this.keywords, content: this.keywordcontent},
    {name: this.desc, content: this.desccontent},
    {name: 'robots', content: 'index, follow'}
  ]);

  }

  

}
